export default __webpack_public_path__ + "static/media/concierge.inline.742203b8.svg";